import { Box } from "@bca/ui-library";

interface CTAsProps {
  first: any;
  second?: any;
}

const CTAs: React.FunctionComponent<CTAsProps> = ({ first, second = null }) => {
  return (
    <Box display="flex" flexDirection="row" height={42}>
      {first}
      {second}
    </Box>
  );
};

export default CTAs;
